import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6502d260"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-form__title" }, " Вход или регистрация ", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-form__subtitle" }, " Авторизуйтесь и получите доступ ко всем возможностям проекта ", -1 /* HOISTED */))
const _hoisted_3 = {
  key: 0,
  class: "system-alert danger"
}
const _hoisted_4 = { class: "system-alert__wrapper" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flat-form__textalert" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "ttl"
}
const _hoisted_9 = {
  key: 0,
  class: "ttl"
}
const _hoisted_10 = { class: "flat-form" }
const _hoisted_11 = {
  key: 0,
  class: "help-block"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "auth-form__back"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_16 = {
  key: 2,
  class: "auth-form__or"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_socials = _resolveComponent("socials")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    ($data.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString($data.error), 1 /* TEXT */)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              innerHTML: $props.modelValue.sendCodePageSetting?.sendCodeText
            }, null, 8 /* PROPS */, _hoisted_7),
            ($data.currentTime > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!$data.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Срок действия кода истекает через: " + _toDisplayString($data.currentTime) + " сек.", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!$data.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Время отправки истекло, попробуйте позже."))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
          ])
        ])),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        class: _normalizeClass(["form-group field-code", $data.inputError ? 'has-error' : ''])
      }, [
        _withDirectives(_createElementVNode("input", {
          id: "code",
          ref: "code",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.code) = $event)),
          type: "number",
          class: "form-control",
          name: "code",
          maxlength: "5",
          placeholder: "Код подтверждения",
          "aria-required": "true",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => ($options.onSendCode()), ["enter"])),
          onKeypress: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.noSymbols && $options.noSymbols(...args)))
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelText, $data.code]
        ]),
        ($data.inputError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($data.inputError), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createElementVNode("button", {
        disabled: $data.disabled,
        class: _normalizeClass(["auth-form__btn button button-primary", {'button-loading': this.loading}]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.onSendCode()))
      }, "Проверить ", 10 /* CLASS, PROPS */, _hoisted_12),
      ($data.ttlShowSendSmsMethod < 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($data.sendingSms)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  ($data.ttlShowSendSmsMethod < 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Повторная отправка"))
                    : _createCommentVNode("v-if", true),
                  _hoisted_14
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.onSendSms())),
                    class: "auth-form__back"
                  }, "Отправить повторно"),
                  _hoisted_15
                ], 64 /* STABLE_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("a", {
        class: "auth-form__back",
        onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.backToLogin()))
      }, "Вернуться на предыдущий шаг")
    ]),
    ($options.showOAuth())
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, "или используйте"))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_socials, { service: $props.service }, null, 8 /* PROPS */, ["service"])
  ], 64 /* STABLE_FRAGMENT */))
}